import http from 'hub-http/clients/apiClient';
export function getAllActionOutputs(flowId) {
  return http.get(`automationplatform/v1/output-fields/flow/${flowId}/allOutputs`);
}